export const errList = {
  1: { icon: "warning_amber", color: "box-icon-yellow" },
  5: { icon: "highlight_off", color: "box-icon-red" },
  4: { icon: "notification_important_outlined", color: "box-icon-black" },
  6: { icon: "power_off_outlined", color: "box-icon-black" },
  8: { icon: "outlet_outlined ", color: "box-icon-black" },
};

// errType 4 e 6 são tratados como offline (mesma regra do email, tempStatus no backend)
export const isOffline = (errType) => Number(errType) === 4 || Number(errType) === 6;

// temperatura crítica (diferença > 3 °C do setpoint) sem cooling down/defrost.
// Diferente de 2 e 3, entra no email de alerta (falha) e em Consultas.
export const ERR_CRITICAL = 5;

// cooling down (2) e defrost (3) só aparecem no email de monitoramento
export const isMonitoringOnly = (errType) => Number(errType) === 2 || Number(errType) === 3;

// erro exibido em Consultas
export const isQueryErr = (errType) => Number(errType) > 0 && !isMonitoringOnly(errType);

export const tempOrOffline = (errType, value) => (isOffline(errType) ? "Offline" : value);
